export default __webpack_public_path__ + "static/media/(27).e0e47164.jpg";